import {REGION, LANGUAGE_TAG_FOR_LOCALE_STRING} from '../constant';
import {IRegion} from '../type';

interface IAbbreviation {
  unit: number;
  suffix: [string, string];
  max: number;
}

const ABBR_KOR: IAbbreviation = {
  unit: 10000,
  suffix: ['만', '억'],
  max: 999900000000,
};
const ABBR: IAbbreviation = {
  unit: 1000,
  suffix: ['K', 'M'],
  max: 999000000,
};

const NUMBER_FORMAT_OPTION: Intl.NumberFormatOptions = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 1,
};

// 참고: https://podotree.atlassian.net/wiki/spaces/KW/pages/1251737640/Client#1.-Count-%ED%91%9C%EA%B8%B0
export function formatNumberMk(
  value: number,
  options?: {
    region?: IRegion;
    max?: number;
  }
): string {
  const region: IRegion = options?.region ?? REGION;
  const {unit, suffix, max: defaultMax} = region === 'kor' ? ABBR_KOR : ABBR;

  if (value < unit) {
    return formatNumber(value);
  }

  const max = options?.max ?? defaultMax;

  let prefix = '';
  if (value > max) {
    value = max;
    prefix = '+';
  }

  const exponent = round(value / unit, 0.1) >= unit ? 2 : 1;

  return `${prefix}${(value / Math.pow(unit, exponent)).toLocaleString(
    LANGUAGE_TAG_FOR_LOCALE_STRING[region],
    NUMBER_FORMAT_OPTION
  )}${suffix[exponent - 1]}`;
}

/**
 * @param fixedPosition 기본값 = 0, 1이면 0.1, 2면 0.01, 최대는 20
 */
export function formatNumber(value: number, fixedPosition = 0): string {
  return value.toLocaleString(LANGUAGE_TAG_FOR_LOCALE_STRING[REGION], {
    // 소수점 자리수는 기본값이 3이라 최대값인 20으로 변경한다.
    maximumFractionDigits: 20,
    minimumFractionDigits: fixedPosition > 20 ? 20 : fixedPosition,
  });
}

export function formatNumberWithMax(value: number, max = 999999) {
  return value <= max ? formatNumber(value) : `${formatNumber(max)}+`;
}

/**
 * 소수 첫째 자리에서 반올림: position 1
 * 소수 둘째 자리에서 반올림: position 0.1
 * 정수 첫째 자리에서 반올림: position 10
 */
export function round(value: number, position = 1) {
  if (!position) {
    return value;
  }
  const x = 1 / position;
  return Math.round(value * x) / x;
}

export function getIsUnderDiffThreshold({
  value,
  target,
  threshold,
}: {
  value: number;
  target: number;
  threshold: number;
}) {
  return Math.abs(value - target) < threshold;
}
